<ion-card
  *mobxAutorun
  class="ion-no-margin ly-col ion-align-items-center md-border"
>
  <ion-text color="dark" class="ion-margin-top">
    <h2 class="ion-no-margin">
      <ion-skeleton-text
        *ngIf="pendingPostCount === undefined"
        style="width: 30px;"
      >
      </ion-skeleton-text>
      <b>{{ pendingPostCount }}</b>
    </h2>
  </ion-text>
  <ion-text color="dark">
    <b>
      <ion-skeleton-text
        *ngIf="pendingPostCount === undefined"
        style="width: 80px;"
      >
      </ion-skeleton-text>
      <ng-container *ngIf="pendingPostCount !== undefined">
        {{ 'workspace.dashboard.gettingStarted.pendingPosts.text' | translate }}
      </ng-container>
    </b>
  </ion-text>
  <ion-row
    class="ion-margin-top md-border-top stretch-x flex-no-wrap actions"
    (click)="approveAll()"
  >
    <ion-button
      class="ion-no-margin md-border-end flex"
      fill="clear"
      expand="full"
      (click)="approveAll()"
      [disabled]="pendingPostCount === 0 || pendingPostCount === undefined"
    >
      <ion-icon name="checkmark-circle-outline" slot="start" class="flex-none">
      </ion-icon>
      {{ 'components.pendingPostsManager.buttons.approveAll' | translate }}
    </ion-button>
    <ion-button
      class="ion-no-margin"
      fill="clear"
      expand="full"
      (click)="viewPending()"
    >
      <ion-icon
        name="arrow-forward-circle-outline"
        slot="start"
        class="flex-none"
      >
      </ion-icon>
      {{ 'components.pendingPostsManager.buttons.viewPending' | translate }}
    </ion-button>
  </ion-row>
</ion-card>
